import { connect } from 'react-redux';
import Feed from './component';
import {
  getUsers, goToProfile, postMatch, getMatches, getProfilePhoto,
} from '../../actions';

export const mapStateToProps = state => (
  {
    user: state.user,
    users: state.feed.users,
    questions: state.user.answers,
    usersRecip: state.matches.usersRecip,
    usersNoRecip: state.matches.usersNoRecip,
    numRequests: state.matches.requests,
    filter: state.feed.filter,
    feedLoading: state.feed.feedLoading,
  }
);

export default connect(mapStateToProps, {
  getUsers, goToProfile, postMatch, getMatches, getProfilePhoto,
})(Feed);
